import {
  Menu,
  MenuItem,
  FormControlLabel,
  Divider,
  Grid2,
  IconButton,
  Tooltip,
  Checkbox,
  Collapse
} from "@mui/material";
import MaterialBox from "../../../../components/MaterialBox";
import MaterialTypography from "../../../../components/MaterialTypography";
import { ExpandMore, FilterAltOff } from "@mui/icons-material";
import { useState } from "react";
import { useSnackbar } from "../../../../context/popup";
import { useLoading } from "../../../../components/Loading";
import { fetchData } from "../../../../services";
import DropDownConfig from "../../../Utils/DropDownConfig";


const MotorModelListFilter = ({ anchorEl, open, onClose, filterData, setFilterData, onApply }) => {

    const {setCircleLoading} = useLoading();
    const {showSnackbar} = useSnackbar();

    const sectionHeader = {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "2px 6px",
        background: "#e9ecf5",
        borderRadius: "6px",
        cursor: "pointer",
        mb: 0.5,
    };

    const menuItemStyle = {
        borderRadius: "6px",
        my: 0.2,
        mx: 0.5,
        py: 0.3,
        "&:hover": { backgroundColor: "#dfe6ff" },
    };

    const labelStyle = {
        m: 0,
        "& .MuiFormControlLabel-label": { fontSize: "0.8rem" },
    };

    //accordian states
    const [openActive, setOpenActive] = useState(false);
    const [openMotorCategory, setOpenMotorCategory] = useState(false);
    const [openMotorMake, setOpenMotorMake] = useState(false);
    const [motorCategoryOptions, setMotorCategoryOptions] = useState([]);
    const [motorMakeOptions, setMotorMakeOptions] = useState([]);

    const fetchMotorCategoryList = async () => {
        setCircleLoading(true);
        try {
            const response = await fetchData(`/reference/general/key-value-store?dropdown=true&code=${DropDownConfig?.motorCategory}`)

            if(response?.success){
                const formattedCategories = response?.data?.items?.map((item) => ({
                    value: item.id,
                    label: item.keyName,
                }));
                setMotorCategoryOptions(formattedCategories)
            }
            else{
                //throw error
                showSnackbar("Error Fetching Country List", "error")
            }
        } catch (error) {
            console.error('Error Fetching Countries:', error);
            showSnackbar("Error Fetching Country List", "error")
        }
        finally{
            setCircleLoading(false);
        }
    };

    const fetchMotorMakeList = async () => {
        
        setCircleLoading(true);
        try {
            const response = await fetchData(`/reference/motor/mmv/makes?dropdown=true&isActive=true`)

            if(response?.success){
                const formattedMotorMakes = response?.data?.items?.map((item) => ({
                    value: item.id,
                    label: item.name,
                }));
                setMotorMakeOptions(formattedMotorMakes)
            }
            else{
                //throw error
                showSnackbar("Error Fetching Country List", "error")
            }
        } catch (error) {
            console.error('Error Fetching Countries:', error);
            showSnackbar("Error Fetching Country List", "error")
        }
        finally{
            setCircleLoading(false);
        }
    }
    
    const handleChange = ({ target: { name, value } }) => {
        setFilterData(prev => ({
            ...prev,
            [name]: value
        }));
    };


    const onClearFilters = () => {
        setFilterData({
            isActive: "",
            motorCategoryId: "",
            motorMakeId: ""
        });
    };


  return (
    <Menu
      anchorEl={anchorEl}
      open={open}
      onClose={onClose}
      sx={{backgroundColor: "rgba(0, 0, 0, 0.3)",}}
      PaperProps={{
          elevation: 3,
          sx: {
            width: 250,
            padding: 1.5            
          },
      }}
    >
        <MaterialBox
        sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
        }}
        >
            {/* Title */}
            <MaterialTypography variant="body2" fontWeight="bold">
                Motor Model Filter
            </MaterialTypography>

            {/* Clear Button */}
            <Tooltip title="Clear Filter" disableInteractive>
                <IconButton
                    size="small"
                    onClick={onClearFilters}
                    sx={{ color: "#ce0707ff" }}
                >
                    <FilterAltOff />
                </IconButton>
            </Tooltip>
        </MaterialBox>


      {/* Content */}
        <MaterialBox ml={1} mt={1} sx={{
        maxHeight: 300, 
        overflowY: "auto"}}>
            <Grid2 container spacing={1}>
                {/* Active Status */}
                <Grid2 size={{xs:12}}>
                    <MaterialBox>
                        <MaterialBox sx={sectionHeader} onClick={() => setOpenActive(!openActive)}>
                        <MaterialTypography variant="body3" fontWeight="bold">
                            Active Status
                        </MaterialTypography>

                        <IconButton size="small">
                            <ExpandMore
                            sx={{
                                transform: openActive ? "rotate(180deg)" : "rotate(0deg)",
                                transition: "0.2s",
                            }}
                            />
                        </IconButton>
                        </MaterialBox>

                        <Collapse in={openActive}>
                        <MenuItem
                            disableRipple
                            sx={menuItemStyle}
                            onClick={() =>
                            handleChange({
                                target: { name: "isActive", value: true },
                            })
                            }
                        >
                            <FormControlLabel
                            control={<Checkbox size="small" checked={filterData.isActive === true} />}
                            label="Active"
                            sx={labelStyle}
                            />
                        </MenuItem>

                        <MenuItem
                            disableRipple
                            sx={menuItemStyle}
                            onClick={() =>
                            handleChange({
                                target: { name: "isActive", value: false },
                            })
                            }
                        >
                            <FormControlLabel
                            control={<Checkbox size="small" checked={filterData.isActive === false} />}
                            label="Inactive"
                            sx={labelStyle}
                            />
                        </MenuItem>
                        </Collapse>
                    </MaterialBox>
                </Grid2>
                {/* Motor Category */}
                <Grid2 size={{xs:12}}>
                    <MaterialBox>
                        {/* <MaterialBox sx={sectionHeader} onClick={() => {
                            setOpenMotorCategory(!openMotorCategory);
                        }}
                        > */}
                        <MaterialBox sx={sectionHeader} onClick={() => {
                            const nextState = !openMotorCategory;
                            setOpenMotorCategory(nextState);

                            if (nextState && motorCategoryOptions.length === 0) {
                                fetchMotorCategoryList();
                            }
                        }}
                        >
                        <MaterialTypography variant="body3" fontWeight="bold">
                            Motor Category
                        </MaterialTypography>

                        <IconButton size="small">
                            <ExpandMore
                            sx={{
                                transform: openMotorCategory ? "rotate(180deg)" : "rotate(0deg)",
                                transition: "0.2s",
                            }}
                            />
                        </IconButton>
                        </MaterialBox>

                        <Collapse in={openMotorCategory}>
                        {motorCategoryOptions?.map((item) => (
                            <MenuItem
                            key={item.value}
                            disableRipple
                            sx={menuItemStyle}
                            onClick={() =>
                                handleChange({
                                target: { name: "motorCategoryId", value: item.value },
                                })
                            }
                            >
                            <FormControlLabel
                                control={<Checkbox size="small" checked={filterData.motorCategoryId === item.value} />}
                                label={item.label}
                                sx={labelStyle}
                            />
                            </MenuItem>
                        ))}
                        </Collapse>
                    </MaterialBox>
                </Grid2>
                {/* Motor Make */}
                <Grid2 size={{xs:12}}>
                    <MaterialBox>
                        <MaterialBox sx={sectionHeader} onClick={() => {
                            const nextState = !openMotorMake;
                            setOpenMotorMake(nextState);

                            if (nextState && motorMakeOptions.length === 0) {
                                fetchMotorMakeList();
                            }
                        }}
                        >
                        <MaterialTypography variant="body3" fontWeight="bold">
                            Motor Make
                        </MaterialTypography>

                        <IconButton size="small">
                            <ExpandMore
                            sx={{
                                transform: openMotorMake ? "rotate(180deg)" : "rotate(0deg)",
                                transition: "0.2s",
                            }}
                            />
                        </IconButton>
                        </MaterialBox>

                        <Collapse in={openMotorMake}>
                        {motorMakeOptions?.map((item) => (
                            <MenuItem
                            key={item.value}
                            disableRipple
                            sx={menuItemStyle}
                            onClick={() =>
                                handleChange({
                                target: { name: "motorMakeId", value: item.value },
                                })
                            }
                            >
                            <FormControlLabel
                                control={<Checkbox size="small" checked={filterData.motorMakeId === item.value} />}
                                label={item.label}
                                sx={labelStyle}
                            />
                            </MenuItem>
                        ))}
                        </Collapse>
                    </MaterialBox>
                </Grid2>
            </Grid2>

        </MaterialBox>

        <Divider />

        {/* Apply button */}
        <MenuItem
        onClick={() => onApply()}
        disableRipple
        sx={{
            padding: "6px 16px", 
            width: "fit-content",
            minWidth: "0px",
            mx: "auto",  
            borderRadius: "6px",
            backgroundColor: "#bcc7e9",
            color: "white",
            display: "flex",
            justifyContent: "center",
            transition: "0.2s ease",

            "&:hover": {
            backgroundColor: "#93a6e8",
            }
        }}
        >
        <MaterialTypography variant="button" fontWeight="bold">
            APPLY FILTER
        </MaterialTypography>
        </MenuItem>
    </Menu>
  );
};

export default MotorModelListFilter;
